import { useTranslation } from 'react-i18next';

const ProgressControl = ({value}) => {
    const { t } = useTranslation();

    const progressObj = {
        "yet_to_start": t('yet_to_start'),
        "in_progress": t('in_progress'),
        "completed": t('completed'),
        "finished": t('finished'),
        "yettoparticipate": t("yet_to_participate"),
        "did_not_participated": t("did_not_participated"),
        "participated_partially": t("participated_partially"),
        "not_conducted":t("not_conducted"),
        "did_not_partake": t("did_not_partake"),
        "yet_to_be_unlocked": t("yet_to_be_unlocked"),
        "yet_to_be_scheduled": t("yet_to_be_scheduled")
    }

    return !!progressObj[value.toLowerCase()] ? progressObj[value.toLowerCase()] : value;
}

export default ProgressControl;